import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpSecureFileService } from '../../service/http-secure-file.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtpAuthService } from '../../service/otp-auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-otp',
	templateUrl: './otp.component.html',
	styleUrls: ['./otp.component.scss'],
	standalone: false
})
export class OtpComponent implements OnInit {

	otpForm: FormGroup;
	shortUrlCode!: string;
	smsId!: number;

	disableValidate = false;

	error = "You have accessed this page with an incorrect URL. Please close this tab and try again with a valid URL sent via SMS";

	constructor(
		private fb: FormBuilder,
		private httpService: HttpSecureFileService,
		private route: ActivatedRoute,
		private toastr: ToastrService,
		private otpAuth: OtpAuthService,
		private router: Router) {
		this.otpForm = this.fb.group({
			otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern(/^\d+$/)]],
		});
	}

	ngOnInit(): void {
		var code = this.route.snapshot.paramMap.get('shortUrlCode');
		if (code) {
			this.shortUrlCode = code;
			this.validateShortUrlCode();
			return;
		} 

		this.smsId = Number(this.route.snapshot.paramMap.get('smsId'));
		if (!this.smsId) {
			this.disableValidate = true;
			this.toastr.error(this.error);
			return;
		}
	}

	validateShortUrlCode() {
		this.httpService.validateShortUrlCode(this.shortUrlCode)
			.subscribe({
				next: (res) => {
					console.log('Short URL validated successfully:', res);
					window.location.href = res.redirectUrl;
				},
				error: (err) => {
					this.disableValidate = true;
					console.error('Error validating Short URL Code', err);
					this.toastr.error('Unauthorized: Invalid Short URL Code');
				}
			});
	}

	onSubmit(): void {
		if (this.otpForm.valid) {
			// this.authService.doAuthenticate(this.loginForm.get('username')!.value, this.loginForm.get('password')!.value, '')
			// .subscribe(result => {

			// })
			this.httpService.validate(this.smsId, this.otpForm.get('otp')!.value)
			.subscribe({
				next: (res) => {
					console.log('OTP validated successfully');
					this.otpAuth.markValidated(this.smsId, this.otpForm.get('otp')!.value);
					this.router.navigate(['/files']);
				},
				error: (err) => {
					console.error('Error validating OTP', err);
					this.toastr.error('Unauthorized: Invalid OTP');
				}
			});
		}
	}
}
